import { render, staticRenderFns } from "./GridOrdersBooking.vue?vue&type=template&id=6de0c2a4&"
import script from "./GridOrdersBooking.vue?vue&type=script&lang=js&"
export * from "./GridOrdersBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6de0c2a4')) {
      api.createRecord('6de0c2a4', component.options)
    } else {
      api.reload('6de0c2a4', component.options)
    }
    module.hot.accept("./GridOrdersBooking.vue?vue&type=template&id=6de0c2a4&", function () {
      api.rerender('6de0c2a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ordersBooking/grid/GridOrdersBooking.vue"
export default component.exports